import { render, staticRenderFns } from "./TabHeaderActions.vue?vue&type=template&id=158c068a&scoped=true&"
import script from "./TabHeaderActions.vue?vue&type=script&lang=js&"
export * from "./TabHeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./TabHeaderActions.vue?vue&type=style&index=0&id=158c068a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158c068a",
  null
  
)

export default component.exports